import * as Yup from 'yup';

import { Column } from '~components/table-view-v3';

const columns: Column[] = [
  {
    id: 'sah_budget_id',
    header: 'Budget ID',
    type: 'text',
    validation: Yup.string().required('Budget ID is required'),
  },
  {
    id: 'start_date',
    header: 'Start Date',
    type: 'date',
    validation: Yup.string().required('Start date is required'),
  },
  {
    id: 'end_date',
    header: 'End Date',
    type: 'date',
    validation: Yup.string()
      .required('End date is required')
      .test('end-after-start', 'End date must be after start date', function (value) {
        const { start_date } = this.parent;
        if (!value || !start_date) return true;
        return new Date(value) >= new Date(start_date);
      }),
  },
  {
    id: 'total_amount',
    header: 'Total',
    type: 'currency',
    classNames: { header: 'header-align-right', cell: 'cell-align-right' },
  },
  {
    id: 'used_amount',
    header: 'Used',
    type: 'currency',
    classNames: { header: 'header-align-right', cell: 'cell-align-right text-danger' },
  },
  {
    id: 'available_amount',
    header: 'Available',
    type: 'currency',
    isEditable: false,
    classNames: { header: 'header-align-right', cell: 'cell-align-right text-success' },
    deriveValue: (row) => (row.total_amount ?? 0) - (row.used_amount ?? 0),
  },
  {
    id: 'is_archived',
    header: 'Is Archived',
    type: 'checkbox',
    classNames: { header: 'header-align-center', cell: 'cell-align-center' },
  },
];

export default columns;
